import { render } from "./AddLab.vue?vue&type=template&id=3a5071c7"
import script from "./AddLab.vue?vue&type=script&lang=js"
export * from "./AddLab.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/AddLab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a5071c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a5071c7', __exports__)) {
    console.log('reload')
    api.reload('3a5071c7', __exports__)
  }
  
  module.hot.accept("./AddLab.vue?vue&type=template&id=3a5071c7", () => {
    console.log('re-render')
    api.rerender('3a5071c7', render)
  })

}


export default __exports__